"use strict";

exports.__esModule = true;
exports.localeKeyMapping = exports.importMomentLocales = void 0;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var importMomentLocales = exports.importMomentLocales = function importMomentLocales(localeKey) {
  switch (localeKey) {
    case "de-de":
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require("moment/locale/de"));
      });
      break;
    case "es-es":
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require("moment/locale/es"));
      });
      break;
    case "fi-FI":
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require("moment/locale/fi"));
      });
      break;
    case "fr-fr":
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require("moment/locale/fr"));
      });
      break;
    case "it-it":
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require("moment/locale/it"));
      });
      break;
    case "ja-jp":
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require("moment/locale/ja"));
      });
      break;
    case "ko-kr":
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require("moment/locale/ko"));
      });
      break;
    case "pl-pl":
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require("moment/locale/pl"));
      });
      break;
    case "pt-PT":
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require("moment/locale/pt"));
      });
      break;
    case "hu-hu":
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require("moment/locale/hu"));
      });
      break;
    case "pt-BR":
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require("moment/locale/pt-br"));
      });
      break;
    case "zh-cn":
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require("moment/locale/zh-cn"));
      });
      break;
    default:
      break;
  }
};
var localeKeyMapping = exports.localeKeyMapping = {
  "de-de": "de",
  "es-es": "es",
  "fi-FI": "fi",
  "fr-fr": "fr",
  "it-it": "it",
  "ja-jp": "ja",
  "ko-kr": "ko",
  "pl-pl": "pl",
  "hu-hu": "hu",
  "pt-BR": "pt-br",
  "zh-cn": "zh-cn",
  "en-us": "en"
};